import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-brown/15 bg-bg-secondary py-10" data-id="element-69" data-mp="207kpmihiaiaw">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 text-center sm:px-6" data-id="element-70" data-mp="207awim15zv0z">
        <p className="font-heading text-lg font-bold uppercase tracking-wide text-ink" data-id="element-71" data-mp="2f2qydd7zkv7x">
          🔨 Manuales Listos
        </p>
        <a href="mailto:manualeslistos@gmail.com" className="flex items-center gap-1.5 text-sm text-muted transition-colors hover:text-brown" data-id="element-72" data-mp="1mfwg8myn67xm">
          <MailIcon size={14} data-id="element-73" data-mp="1hie2mj9oj4ja" />
          manualeslistos@gmail.com
        </a>
        <p className="text-xs text-muted" data-id="element-74" data-mp="1w67im52og92e">Pago único · Acceso inmediato · 7 días de garantía</p>
        <p className="text-xs text-muted/70" data-id="element-75" data-mp="1rez9zb968rqa">
          © Manuales Listos {new Date().getFullYear()} — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}